export const DEFAULT_ROWS_PER_PAGE_FOR_CATALOGUE = 15;

export enum Sidebar {
  INCLUDED_PRODUCTS = 'included-products',
}
